var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#ac212e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.06,141.07H215.41a4,4,0,0,0,4-4V111a17,17,0,0,0-17-17H124a17,17,0,0,0-17,17v26.06A4,4,0,0,0,111.06,141.07Zm4-30.06a9,9,0,0,1,9-9h78.43a9,9,0,0,1,9,9v22.06H115.06ZM215,162a5.37,5.37,0,0,1-5.36-5.36,4,4,0,0,0-8,0A13.38,13.38,0,0,0,215,170a14.74,14.74,0,0,1,14.73,14.72v23.54a4,4,0,0,0,8,0V184.69A22.75,22.75,0,0,0,215,162Zm18.73,119.87H205.05a24.9,24.9,0,0,1,0-49.79h11.74a4,4,0,1,0,0-8H205.05A32.87,32.87,0,0,0,183.73,282H111.51a14.73,14.73,0,0,1-14.72-14.72V184.69A14.73,14.73,0,0,1,111.51,170a13.38,13.38,0,0,0,13.36-13.36,4,4,0,0,0-8,0,5.37,5.37,0,0,1-5.36,5.36,22.74,22.74,0,0,0-22.72,22.72v82.54A22.74,22.74,0,0,0,111.51,290H215a3.82,3.82,0,0,0,.9-.11h17.83a4,4,0,0,0,0-8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.32,224.05H233.69a4,4,0,0,0-4,4v39.18a4,4,0,0,0,8,0V232.05h24.63a24.9,24.9,0,0,1,0,49.79H250.58a4,4,0,1,0,0,8h11.74a32.9,32.9,0,0,0,0-65.79Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.45,193.93H167.23V177.72a4,4,0,0,0-8,0v16.21H143a4,4,0,0,0,0,8h16.21v16.21a4,4,0,0,0,8,0V201.93h16.22a4,4,0,0,0,0-8Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharma);
export default __webpack_public_path__ + "static/media/pharma.6912ca7571c13307c3b48a5d89a74095.svg";
export { ForwardRef as ReactComponent };